import { Injectable, EventEmitter } from '@angular/core';
import {
  HttpClient,
  HttpResponse,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { IRegister } from '../models/register.model';
import { IRegisterOutput } from '../models/registeroutput.model';
import { AuthenticationService } from '../auth/authentication.service';
import { RestService } from '../providers/rest.service';
import { IUser } from '../models/user';
import { TokenService } from '../../shared/providers/token.service';
import { map } from 'rxjs/operators';

@Injectable()
export class RegisterService extends RestService {
  constructor(
    protected _http: HttpClient,
    private router: Router,
    private authenticationService: AuthenticationService,
    private tokenService: TokenService
  ) {
    super(_http);
  }

  registerUser(registerModel: IRegister): Observable<IUser> {
    return this.postForEntityObject<IUser>(
      '/auth/register',
      registerModel
    ).pipe(
      map((response) => {
        this.authenticationService.authResponse = response;
        localStorage.setItem('currentUser', JSON.stringify(response));
        if (response.Success) {
          this.authenticationService.isAuthenticated = true;
          localStorage.setItem(
            'auth_token',
            this.authenticationService.authResponse.Token
          );
          localStorage.setItem(
            'auth_token_expiry',
            this.tokenService.GetTokenExpiryDate().toString()
          );
          this.authenticationService._user = JSON.parse(
            localStorage.getItem('currentUser')
          );
          this.authenticationService.loggedIn.next(true);
          this.authenticationService.removeLocalStorage();
          response.RedirectUrl = this.authenticationService.redirectUrl;
          return this.authenticationService.authResponse;
        } else {
          localStorage.removeItem('currentUser');
          this.authenticationService.isAuthenticated = false;
          this.authenticationService._user = null;
          return this.authenticationService.authResponse;
        }
      })
    );
  }
}
